const isUserBrowserIE = () => {
    const { userAgent } = navigator;
    if (userAgent.indexOf('MSIE') !== -1
    || userAgent.indexOf('Trident') !== -1
    ) {
        return true;
    }
    return false;
};

export default isUserBrowserIE;
